export const BASE_SITE_TITLE = 'Midst'
export const BASE_SITE_PAGE_TITLE = BASE_SITE_TITLE + ':'
export const POEM_ARROW_KEY: 'timeline' | 'slide' = 'timeline'
